import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormSelectInput from '../general-input-form/FormSelectInput'

const AppFormExportSalary = ({
  errors,
  statusContractOptions,
  statusContract,
  handleSelectStatusContract,
  monthOptions,
  month,
  handleSelectMonth
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormSelectInput 
          id='month'
          name='month'
          colSize='6'
          inputLabel='Select Month'
          className='mb-3'
          selectOptions={monthOptions}
          value={month}
          handleSelectInput={handleSelectMonth}
          feedbackInvalid={errors.month}
          invalid={errors.month}
          disabled={false}
          placeholder='Please select month...'
        />
        <FormSelectInput 
          id='employee_status'
          name='employee_status'
          colSize='6'
          inputLabel='Employee Type'
          className='mb-3'
          selectOptions={statusContractOptions}
          value={statusContract}
          handleSelectInput={handleSelectStatusContract}
          feedbackInvalid={errors.employee_status}
          invalid={errors.employee_status}
          disabled={false}
          placeholder='Please select employee type...'
        />
      </CRow>
    </>
  )
}

export default AppFormExportSalary